<template>
	<div id="app" v-bind:class="getMainClass()" ref="main">
		<route v-if="!loading"></route>
		<error v-if="errorMessage"></error>
	</div>
</template>

<script>
import config from './config';
import error from './components/error.vue';
import route from './components/route/route.vue';
import filters from './filters/formatter.js';
import parcelFilters from './filters/parcel.js';

export default {
	name: 'app',
	components:{
		error,
		route
	},	
	created: function(){

		let device;

		// check window size
		if (window.innerWidth < 576 || window.innerHeight < 576){
			// phone in portrait
			device = 'mobile';
		} else {
			device = 'desktop';
		}

		//	any setup that needs to happen in the store
		this.$store.dispatch('AGENT_INIT');
		this.$store.dispatch('DEVICE_TYPE_SET',device);
		this.$store.dispatch('SCROLL_MARGIN_TOP_SET',{device:device});

		if (device === 'mobile'){
			this.scrolling = true;
		} else {
			this.scrolling = false;
		}

		this.loading = false

		//	google analytics tracking
		gtag('config', config.googleAnalytics.trackingId);
	},
	computed: {
		errorMessage: function(){
			return this.$store.state.error.message;
		},
		parcel: function() {
			return this.$store.state.parcel;
		},
		token: function(){
			return this.$store.state.agent.token;
		},
		planLoaded: function(){
			return this.$store.state.plan.loaded;
		},
		deviceType:function(){
			return this.$store.state.device.type;
		},
		scrollTop:function(){
			return this.$store.state.scroll.top;
		}
	},
	data:function(){
		return {
			loading: true,
			scrolling: false
		};
	},
	methods:{
		getMainClass:function(){
			let cl = this.deviceType;
			cl += (this.deviceType === 'mobile')? ' min-h-100': ' h-100';
			return cl;
		},
		bindScroll:function(){
			if (this.scrolling){
				window.addEventListener('scroll', this.handleScroll);
			}
		},
		handleScroll:function(e){
			e.stopPropagation();
			return false;
		}
	},
	mounted:function(){
		this.bindScroll();
	},
	watch: {
		scrollTop:function(scrollNew){
			if (scrollNew === -1) return;

			if (this.scrolling){
				window.scrollTo(0,scrollNew);
				this.$store.dispatch('SCROLL_TOP_RESET',-1);
			}
		}
	}
}
</script>

<style>
html{
	overscroll-behavior:none;
}
body{
	position: relative;
	overscroll-behavior:none;
	position:absolute;
	top:0;bottom:0;left:0;right:0;
}
a, span.link{
	color:#0687D1;
}
a:hover, span.link:hover{
	color:#0676BD;
	cursor: pointer;
}
i{
	vertical-align:middle;
}
*:focus {
	outline: none;
}
a:focus {
	outline: #FDD834 dotted 1px;
}
[v-cloak] {
	display: none;
}
.action-row {
	font-size: 1rem;
  line-height: 1.8rem;
  background-color: #EFEFEF;
  padding:0.5rem;
}
.bg-red {
	background-color: #F43F1D;
}
.bg-transparent {
	background-color: transparent;
}
.bg-gray-lt{
	background-color:#EFEFEF;
}
.bg-red{
	background-color:#CC1717;
}
.bg-purple{
	background-color:#8E24AA;
}
.bg-teal{
	background-color:#009688;
}
.bg-green{
	background-color:#8BC34A;
}
.bg-blue{
	background-color:#0676BD;
}
.bg-dk{
	background-color:#273237 !important;
}
.bg-blue-dk{
	background-color:#37474F !important;
}
.bg-even-gray:nth-child(even){
	background-color:#FAFAFA;
}
.border-bottom-gray{
	border-bottom:1px solid #455963;
}
.btn{
	cursor:pointer;
}
.btn-green{
	background-color:#679E38;
	color:#FFFFFF;
}
.btn-green:hover{
	background-color:#7CB341;
}
.btn-outline-light:hover,.btn-outline-light:active{
	background-color:transparent;
	color:#FFF;
}
.btn-primary{
	background-color:#0687D1;color:#FFF;
}
.btn-primary:hover{
	background-color:#0676BD;
}
.card.no-hover{
	cursor:default; 
}
.category{
	padding-bottom:0.5rem;
}
.category-body{
	position:relative;
	min-height:200px;
}
.locked .category-body{
	padding:0.5rem;
}
.category-title{
	font-size: 0.6rem;
	border-bottom: 1px solid #455963;
	font-weight: 700;
	padding: 0.5rem 0 0.25rem 0;
}
.category-title-btn{
	float:right;
	margin-right:0.25rem;
	cursor:pointer;
}
.category-title-btn:hover{
	color:#0687D1;
}
.collections-list .list-group-item{
	padding-left:44px;
}
.collections-list .list-group-item i{
	position:absolute;left:16px;
}
.collection-list-remove{
	position:absolute;
	right:0;top:0;
	width:34px;
	height:44px;
	line-height:44px;
	text-align:center;
}
.content-actions-close{
	position:absolute;
	width:34px;
	height:44px;
	top:0;right:0;
	line-height:44px;
	text-align:center;
	cursor:pointer;
	opacity:0.8;
}
.content-actions-close:hover{
	opacity:1;
}
.desktop .desktop-scroll-y{
	overflow-y: scroll;
}
.mobile .desktop-scroll-y{
	overflow:hidden;
}
.desktop .desktop-mt-left-col{
	margin-top:44px;
}
.desktop .desktop-h-100{
	height:100%;
}
.flex-1{
	flex:1;
}
.flex-2{
	flex:2;
}
.font-10{
	font-size:10px;
}
.font-12{
	font-size:12px;
}
.font-14,.text-14{
	font-size:14px;
}
.font-16,.text-16{
	font-size:16px;
}
.overflow-hidden{
	overflow:hidden;
}
.cursor-pointer{
	cursor:pointer;
}


.hover-opacity{
	cursor:pointer;
	opacity:0.9;
}
.hover-opacity:hover{
	opacity:1;
}
.hover-dk{
	cursor:pointer;
	background-color:#37474F;
}
.hover-dk:hover{
	background-color:#273237;
}
.icon-lt{
	cursor:pointer;
	color:#CCC;
}
.icon-lt:hover{
	color:#EEE;
}
.icon-gray{
	cursor:pointer;
	color:#BDBDBD;
}
.icon-gray:hover{
	color:#9E9E9E;
}
.icon-green{
	color:#679E38;
}
.icon-green:hover{
	color:#7CB341;
}

.left-col-full{
	position:relative;
}
.desktop .left-col-full{
	z-index:3;
}
.left-col-full h2{
	margin-top:-6px;
	font-size:26px;
	line-height:30px;
}
.left-col-full h5{
	font-size:14px;
	line-height:18px;
}
.left-col-full .field-row{
	font-size:14px;
	line-height:24px;
}
.left-col-full .nav-link{
	padding:0.4rem 0.5rem;
	cursor:pointer;
	color:#CCC;
}
.left-col-full .nav-link:hover{
	color:#EEE;
}
.left-col-full .nav-link.active:hover{
	color:#495057;
}
.left-col-full .options i{
	cursor:pointer;
	color:#868e96;
}
.left-col-full .options i:hover{
	color:#FFFFFF;
}
.left-col-full .options i.green{
	color:#679E38;
}
.left-col-full .options i.green:hover{
	color:#7CB341;
}
@keyframes dot-keyframes {
	0% {
		opacity: .4;
		transform: scale(1, 1);
	}

	50% {
		opacity: 1;
		transform: scale(1.4, 1.4);
	}

	100% {
		opacity: .4;
		transform: scale(1, 1);
	}
}
.left-col-full .loading{
	position:absolute;
	top:0;bottom:0;left:0;right:0;
	background-color:rgba(39,50,55,0.6);
}
.left-col-full .loading-dots {
	text-align: center;
	width:100%;
}
.left-col-full .dot {
	animation: dot-keyframes 1.4s infinite ease-in-out;
	background-color: #FFFFFF;
	border-radius: 20px;
	display: inline-block;
	height:8px;
	width:8px;
}
.left-col-full .dot:nth-child(2) {
	animation-delay: 0.4s;
}
.left-col-full .dot:nth-child(3) {
	animation-delay: 0.8s;
}
.left-col-full.bg-gray-trans{
	background-color:rgba(39,50,55,0.6);
}
.left-col-full.bg-gray-trans{
	background-color:rgba(39,50,55,0.6);
}
.left-col-full.bg-gray-trans .options i{
	color:#EDEFF1;
}
.left-col-full.bg-gray-trans .options i:hover{
	color:#FFF;
}

.link-gray{
	color:#9E9E9E;
}
.link-gray:hover{
	color:#616161;
}

.loading{position:absolute;top:0;bottom:0;left:0;right:0;background-color:rgba(39,50,55,0.6);}

@keyframes dot-keyframes {
	0% {
		opacity: .4;
		transform: scale(1, 1);
	}

	50% {
		opacity: 1;
		transform: scale(1.4, 1.4);
	}

	100% {
		opacity: .4;
		transform: scale(1, 1);
	}
}
.loading-dots {
	text-align: center;
	width:100%;
}
.loading-dots .dot {
	animation: dot-keyframes 1.4s infinite ease-in-out;
	background-color: #FFFFFF;
	border-radius: 20px;
	display: inline-block;
	height:8px;
	width:8px;
}
.loading-dots .dot:nth-child(2) {
	animation-delay: 0.4s;
}
.loading-dots .dot:nth-child(3) {
	animation-delay: 0.8s;
}

.lock-block{
	margin-bottom:1rem;
}
.lock-block.lock-block-sharp{
	border-radius:0;
}

.locked{
}
.locked .locked-property{
	color:transparent;text-shadow:0px 0px 10px #999;
}
.locked .over-action{
	position:absolute;top:0;left:0;right:0;bottom:0;background-color:rgba(55,71,79,0.2);}
.locked .over-action-box{padding:12px 0;width:130px;margin:0 auto;
	text-align:center;color:#fff;border-radius:4px;}

.min-h-100{
	min-height:100%;
}
.mt-left-col{
	margin-top:44px;
}
.modal-bg{
	position:fixed;top:0;bottom:0;left:0;right:0;background-color:rgba(19,26,29,0.6);
}
.modal-property-row{
	margin-bottom:1rem;
}
.mobile-scroll{
	overscroll-behavior: none;
	-webkit-overflow-scrolling: touch;
}

.overflow-visible{
	overflow:visible !important;
}

::placeholder { /* Chrome, Firefox, Opera, Safari 10.1+ */
  color: #CCC !important;
  opacity: 1; /* Firefox */
}
:-ms-input-placeholder { /* Internet Explorer 10-11 */
  color: #CCC !important;
}
::-ms-input-placeholder { /* Microsoft Edge */
  color: #CCC !important;
}

.property-row{
	padding:0.5rem 0 0 0;
	font-size:0.9rem;
	overflow:hidden;
}
.property-row label{
	font-weight:300;
	margin-bottom:0;
}
.property-value-right{
	float:right;
	font-weight:700;
}
.property-row .form-control-sm{margin-top:-5px;}
.undef{
	font-weight:400;
	color:#CCC;
	font-style: italic;
}
.locked .property-locked{
	color:transparent;text-shadow:0px 0px 10px #999;
}

.scroll-y{
	overflow-y: scroll;
}

.section{
	background-color:#FFF;
	border:1px solid #EEEEEE;
	margin-bottom:1rem;
	position:relative;
	min-height:100px;
}
.section-bold{
	border:1px solid #37474F;
}
.section-title{
	background-color:#F5F5F5;
	padding:0.5rem 0.5rem;
	font-weight: 700;
	font-size:0.9rem;
	line-height:1.4;
}
.section-bold .section-title{
	background-color:#37474F;
	color:#fff;
}
.section-body{
	padding:0.25em 0.5em 0.75em 0.5em;
}
.section-footer{
	background-color:#F5F5F5;
	padding:0.5rem 0.5rem;
	font-weight: 700;
	font-size:0.9rem;
	line-height:1.4;
	overflow:hidden;
}
.section-bold .section-footer{
	background-color:#37474F;
	color:#fff;
}

.service-item-body{
	margin-bottom:2rem;
}
.service-item-title{
	font-size:1.1rem;
	line-height:1.5;
	margin-bottom:1rem;
}
.services-list{
	margin:0;
	padding:0;
}
.services-list li{
	list-style-type:none;
	padding:0 0 1rem 0;
	border-bottom:1px solid #EDEFF1;
}

.shadow-dk{
	box-shadow:1px 1px 2px rgba(0,0,0,0.1);
}

.sub-nav{
	margin:0 0 1rem 0;
	padding:0;
}
.sub-nav li{
	border-bottom:1px solid #EFEFEF;
	line-height:2.5rem;
	list-style-type:none;
	font-size:0.8rem;
	opacity:1;
	cursor:pointer;
	position:relative;
	padding-right:18px;
	overflow:hidden;
}
.sub-nav li.inactive{
	color:#9E9E9E;
	cursor:default;
}
.sub-nav li:hover{
	color:#0687D1;
}
.sub-nav li.inactive:hover{
	color:#9E9E9E;
}
.sub-nav li i{
	position:relative;
	top:-1px;
	margin-right:4px;
}
.sub-nav i.arrow-more{
	position:absolute;
	top:10.5px;
	right:-4px;
	margin-right:0;
}
.sub-nav li.inactive .arrow-more{
	display:none;
}
.sub-nav-item-dark{
	color:#fff;
	background-color:#37474F;
}
.sub-nav-title{
	font-size:0.9rem;
}
.sub-nav-value{
	float:right;
	white-space: nowrap;
	}

.text-description{
	word-wrap:break-word;
	white-space: pre-wrap;
}
.text-green{
	color:#7CB341;
}
.text-red{
	color:#CC1717;
}
.text-sm {
  font-size: 0.8em;
}
.text-light-gray{
	color:#8FA3AE !important;
}
.word-wrap-break{
	word-wrap: break-word;
}
.vh-100{
	height:100vh;
}


/* material icons */
.material-icons.md-12{
	font-size: 12px;
}
.material-icons.md-14{
	font-size: 14px;
}
.material-icons.md-18{
	font-size: 18px;
}
.material-icons.md-24{
	font-size: 24px;
}
.material-icons.md-36{
	font-size: 36px;
}
.material-icons.md-48{
	font-size: 48px;
}


</style>



// WEBPACK FOOTER //
// src/app.vue